// A case's risk type. `waiting` and `healthy` are legacy keys for the two
// low-risk types — a feature request and a case with no risk signal — and
// are not case statuses, so they are labelled for what they mean.
export const RISK_LABEL = {
  revenue_trust: "Revenue / Trust Risk",
  sla_operational: "SLA / Operational",
  product_incident: "Product Incident",
  waiting: "Feature request",
  healthy: "No risk signal",
};

// The Decision Radar's top level. Each real risk is its own group; the two
// low-risk types share one parent. Mirrors RISK_GROUP in the read model.
export const RISK_GROUPS = [
  { id: "revenue_trust", label: "Revenue / Trust Risk", types: ["revenue_trust"], badge: "b-rev", node: "radar-node-rev" },
  { id: "sla_operational", label: "SLA / Operational", types: ["sla_operational"], badge: "b-sla", node: "radar-node-sla" },
  { id: "product_incident", label: "Product Incident", types: ["product_incident"], badge: "b-prod", node: "radar-node-prod" },
  { id: "low_risk", label: "Low risk", types: ["waiting", "healthy"], badge: "b-healthy", node: "radar-node-healthy" },
];

export const RISK_CLASS = {
  revenue_trust: "b-rev",
  sla_operational: "b-sla",
  product_incident: "b-prod",
  waiting: "b-wait",
  healthy: "b-healthy",
};

// A case can be involved in several risk classes at once; its other classes
// are drawn as rings round its node in these colours.
export const RISK_COLOR = {
  revenue_trust: "var(--risk-rev)",
  sla_operational: "var(--risk-sla)",
  product_incident: "var(--risk-product)",
};

export const NODE_CLASS = {
  revenue_trust: "radar-node-rev",
  sla_operational: "radar-node-sla",
  product_incident: "radar-node-prod",
  waiting: "radar-node-wait",
  healthy: "radar-node-healthy",
};

export const CATEGORY_LABEL = {
  // Signal kinds, used until the Slice 3 classifier supplies finer categories.
  support_ticket: "Support ticket",
  problem_report: "Problem report",
  feature_request: "Feature request",
  billing_event: "Billing",
  email: "Email",
  other: "Other",
  payment_failed: "Payment failed",
  duplicate_charge: "Duplicate charge",
  refund_request: "Refund request",
  premium_not_activated: "Premium not activated",
  lifetime_purchase_issue: "Lifetime purchase",
  account_access: "Account access",
  angry_customer: "Angry customer",
  legal_privacy: "Legal / privacy",
  data_loss: "Data loss",
  app_unusable: "App unusable",
  product_bug: "Product bug",
  feature_request: "Feature request",
  general_question: "General question",
  // The radar's bucket for cases the classifier left without a category.
  uncategorized: "Uncategorized",
};

export const SOURCE_LABEL = {
  EMAIL: "Email",
  APP_TICKET: "App ticket",
  PROBLEM_REPORT: "Problem report",
  FEATURE_REQUEST: "Feature request",
};

export const PERSONA_QUESTION = {
  founder: "What is putting the business at risk today?",
  support_manager: "Where does my team need help?",
  advisor: "What should I work on next?",
};

export const PERSONA_LABEL = {
  founder: "Founder",
  advisor: "Advisor",
  support_manager: "Support Manager",
};

export const LENSES = [
  { id: "executive", label: "Executive Overview" },
  { id: "revenue_risk", label: "Revenue Risk" },
  { id: "trust_risk", label: "Trust Risk" },
  { id: "my_work", label: "My Work" },
  { id: "team_health", label: "Team Health" },
  { id: "product_health", label: "Product Health" },
  { id: "connector_health", label: "Connector Health" },
];

export const fmtTimeAgo = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  // SLA deadlines are often in the future; render those as time remaining
  // rather than a negative "ago".
  const future = diff < 0;
  const abs = Math.abs(diff);
  const span =
    abs < 60 ? `${Math.floor(abs)}s`
    : abs < 3600 ? `${Math.floor(abs / 60)}m`
    : abs < 86400 ? `${Math.floor(abs / 3600)}h`
    : `${Math.floor(abs / 86400)}d`;
  return future ? `in ${span}` : `${span} ago`;
};
